import { Button, Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTER } from '../../../constants/router';
import ListPrivacy from '../Shared/ListPrivacy';
import { useForm } from 'antd/lib/form/Form';
import DocTabs from './components/DocTabs';
import { usePrivacytoString } from './components/PreviewtoString';
import { PlusOutlined } from '@ant-design/icons';
import { POLICY_NAME } from '../POLICY';
import DPAService from '../../../services/DPA.service';
import usePermission from '../../../hooks/usePermission';

const DataProcessing = ({ selectType }) => {
    const { t, i18n } = useTranslation(['translation', POLICY_NAME.DPA]);
    let lang = i18n.language;
    const [data, setData] = useState([]);
    const [currentSelectList, setCurrentSelectList] = useState();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState();
    const [detailPublished, setDetailPublished] = useState();
    const [logo] = useState('');
    const [logoPublish] = useState('');

    useEffect(() => {
        const getPolicy = async () => {
            setLoading(true);
            try {
                const { data } = await DPAService.getDPADetail(
                    currentSelectList?.dpaPolicyId
                );
                if (data?.resultData) {
                    setDetail(data?.resultData);
                    setLoading(false);
                } else setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };
        const getPublishedVersion = async () => {
            try {
                const { data } = await DPAService.getPublishedVersion(
                    currentSelectList?.dpaPolicyId
                );
                if (data?.resultData) {
                    const parse = JSON.parse(data?.resultData?.data);
                    setDetailPublished(parse);
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (currentSelectList?.dpaPolicyId) getPolicy();
        if (
            currentSelectList?.hasChanged &&
            currentSelectList?.status === 'Published'
        )
            getPublishedVersion();
        else setDetailPublished();
    }, [currentSelectList]);

    let navigate = useNavigate();

    const getPolicyList = async () => {
        const query = {
            dataSubjectTypeIds: selectType ? selectType : '',
        };
        const { data } = await DPAService.searchDPA(query);
        if (data.resultData) {
            setData(data.resultData);
            setCurrentSelectList(data.resultData[0]);
        }
    };

    useEffect(() => {
        getPolicyList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectType]);

    const [form] = useForm();

    const handelRename = (values) => {};

    const { html } = usePrivacytoString(detail);
    const { html: htmlPublish } = usePrivacytoString(detailPublished);

    const { isAuditor } = usePermission();

    return (
        <Layout>
            <div className="flex items-center my-4">
                <div className="flex-1 font-bold text-xl">
                    {t('Data Processing Agreement list', {
                        ns: POLICY_NAME.DPA,
                    })}
                </div>
                <Button
                    disabled={isAuditor}
                    type="primary"
                    size="large"
                    onClick={() => {
                        navigate(`${ROUTER.POLICY.DPA}/new#step1`);
                    }}
                    icon={<PlusOutlined />}
                >
                    {t('Add Policy')}
                </Button>
            </div>
            <div className="grid grid-cols-7 gap-4">
                <ListPrivacy
                    data={data}
                    pathEdit={ROUTER.POLICY.DPA}
                    stepEdit="#step3"
                    currentSelectName={{
                        nameTh: currentSelectList?.dpaName,
                        nameEn: currentSelectList?.dpaName,
                        placeholderNameEN: `${t(
                            'Name of Data Processing Agreement',
                            {
                                ns: POLICY_NAME.DPA,
                            }
                        )} (EN)`,
                        placeholderNameTH: `${t(
                            'Name of Data Processing Agreement',
                            {
                                ns: POLICY_NAME.DPA,
                            }
                        )} (TH)`,
                    }}
                    linkName="external-dpa-policy"
                    getPolicyList={getPolicyList}
                    setCurrentSelectList={setCurrentSelectList}
                    currentSelectList={currentSelectList}
                    form={form}
                    // Parameters Name
                    policyObject={{
                        privacyName: 'dpaName',
                        nameTh: 'dpaName',
                        nameEn: 'dpaName',
                        privacyType:
                            lang === 'en'
                                ? 'dpaPolicyTypeEn'
                                : 'dpaPolicyTypeTh',
                        privacyId: 'dpaPolicyId',
                        privacyCompany: 'ownerCompanyName',
                    }}
                    handelRename={(value) => handelRename(value)}
                    historyObject={{
                        logo: logo,
                        serviceHistory: DPAService.getHistoriesDPA,
                        type: POLICY_NAME.DPA,
                        historyParamName: 'dpaPolicyId', // ชื่อ payload ของ id ที่ service get history เช่น hrPrivacyPolicyId: "1234" ที่ต้องใส่คือ: hrPrivacyPolicyId
                        historyResultIdName: 'dpaPolicyHistoryId', // ได้หลังจาก service get history ใน result ชื่อ parameter ของ id เช่น { "hrPrivacyPolicyHistoryId" : 1234 } ที่ต้องใส่คือ: hrPrivacyPolicyHistoryId
                    }}
                    deleteObject={{
                        serviceDelete: DPAService.delete,
                        title: lang === 'en' ? 'Confirm Delete' : 'ยืนยันการลบ',
                        text:
                            currentSelectList?.status === 'Draft'
                                ? lang === 'en'
                                    ? `Do you want to delete draft version ${currentSelectList?.version} ?`
                                    : `คุณต้องการลบรายการแบบร่างเวอร์ชัน ${currentSelectList?.version} ?`
                                : lang === 'en'
                                ? `<span style='color:#F0536F'>You will not be able to recover the contents of this contract again.
                                Do you want to delete release version ${currentSelectList?.latestPublishVersion} ?</span>`
                                : `<span style='color:#F0536F'>คุณจะไม่สามารถกู้คืนเนื้อหาสัญญานี้ได้อีก
                                คุณต้องการลบรายการเผยแพร่เวอร์ชัน ${currentSelectList?.latestPublishVersion} ?</span>`,
                    }}
                    // pop up ของ confirm ก่อน delete
                    confirmObject={{
                        title:
                            lang === 'en'
                                ? 'This DPA is currently published.'
                                : 'สัญญาประมวลผลข้อมูลส่วนบุคคลฉบับนี้ ถูกเผยแพร่อยู่',
                        text:
                            lang === 'en'
                                ? `Please ensure that you have successfully\ndownloaded this DPA file. You will not be able to recover the content of this DPA.`
                                : `โปรดตรวจสอบว่าได้ดาวน์โหลดไฟล์สัญญานี้ไว้เรียบร้อยแล้ว คุณจะไม่สามารถกู้คืนเนื้อหาสัญญานี้ได้`,
                    }}
                    loading={loading}
                    templateBody={{
                        html,
                        htmlEn: html,
                        htmlPublish: htmlPublish,
                        htmlPublishEn: htmlPublish,
                    }}
                    download={detail?.documentContent?.dpaDetailDocument}
                >
                    {(previewLang) => (
                        <DocTabs
                            logo={logo}
                            logoPublish={logoPublish}
                            detailPublished={detailPublished}
                            detail={detail}
                            loading={loading}
                            currentSelectList={currentSelectList}
                            previewLang={previewLang}
                            policyId={currentSelectList?.dpaPolicyId}
                        />
                    )}
                </ListPrivacy>
            </div>
        </Layout>
    );
};

export default DataProcessing;
